"use strict";import{IconCamera as e}from"../src/elements/IconCamera.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-camera",e);
//# sourceMappingURL=sp-icon-camera.js.map
